import { render, staticRenderFns } from "./SARepoView.vue?vue&type=template&id=3b3fb0b4"
import script from "./SARepoView.vue?vue&type=script&lang=js"
export * from "./SARepoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports